import {Injectable} from '@angular/core';

import {ProfileMode} from '../../app.constants';
import {Destroyable} from '../../destroyable.component';

export interface PendingFileChange {
  fileId: string;
  url?: string;
  authenticated: boolean;
  profileMode: ProfileMode;
}

@Injectable()
export class FileChangesSessionService extends Destroyable {
  public enabled = true;
  public readonly uploads = new Map<string, PendingFileChange>();
  public readonly deletions = new Map<string, PendingFileChange>();
}
